import { useObservationLogs } from '../hooks/use-observation-logs';
import { ObservationLogSection } from './observation-log-section';

// const items: ObservationLog[] = [{
//     Code: {
//         ElectricalObservationClassificationCodeId: '1',
//         HexColorCode: '#FF0000',
//         Kind: 'Minor',
//     },
//     LocationRemark: 'Locatie opmerking 1',
//     CodeKind: 'Minor',
//     Logs: [
//         {
//             ElectricalProjectObservationLogId: 'log1',
//             CreateDate: new Date().toISOString(),
//             Message: 'Dit is het eerste logboek item',
//             NewStatus: 'IssueReported',
//             OldStatus: 'WontSolveIssue',
//             User: {
//                 Email: 'lukas@elektra.nl',
//                 Name: 'Lukas',
//                 OrganizationName: 'Elektra',
//                 UserId: 'user1',
//             },
//         },
//         {
//             ElectricalProjectObservationLogId: 'log2',
//             CreateDate: new Date().toISOString(),
//             Message: 'Dit is het eerste logboek item',
//             NewStatus: 'ToSolveIssue',
//             OldStatus: 'WontSolveIssue',
//             User: {
//                 Email: 'lukas@elektra.nl',
//                 Name: 'Lukas',
//                 OrganizationName: 'Elektra',
//                 UserId: 'user1',
//             },
//         },
//         {
//             ElectricalProjectObservationLogId: 'log3',
//             CreateDate: new Date().toISOString(),
//             Message: 'Dit is het eerste logboek item',
//             NewStatus: 'IssueSolved',
//             OldStatus: 'WontSolveIssue',
//             User: {
//                 Email: 'lukas@elektra.nl',
//                 Name: 'Lukas',
//                 OrganizationName: 'Elektra',
//                 UserId: 'user1',
//             },
//         },
//     ],
// }];

export type ObservationLogsProps = {
    electricalProjectVersionId: string;
};

export function ObservationLogs({ electricalProjectVersionId }: ObservationLogsProps) {
    const { data: {
        items,
    } } = useObservationLogs({
        electricalProjectVersionId,
    });

    return (
        <>
            {items.map(item => (
                <ObservationLogSection key={item.ElectricalProjectObservationId} observationLog={item} />
            ))}
        </>
    );
}
